import setNumberOfAiGeneratedBlocks from './set-number-of-ai-generated-blocks';

export default {
  setNumberOfAiGeneratedBlocks,
};
